<template>
  <section class="consumption-records-mobile">
    <h2>{{ $t('views.account_center.points_details') }}</h2>
    <el-skeleton v-if="isLoading && !records.length" animated :rows="6" class="records-loading" />
    <el-empty v-else-if="!records.length" :description="$t('views.account_center.no_consumption_records')" />
    <ul v-else class="records-list">
      <li v-for="row in records" :key="row._display_key" class="record">
        <h3>{{ eventName(row) }}</h3>
        <dl>
          <div><dt>{{ $t('views.account_center.occurred_at') }}</dt><dd>{{ formatDate(row.create_time) }}</dd></div>
          <div><dt>{{ $t('views.account_center.points_change') }}</dt><dd :class="signedPointsChange(row) >= 0 ? 'is-positive' : 'is-negative'">{{ formatChange(row) }}</dd></div>
          <div><dt>{{ $t('views.account_center.points_balance') }}</dt><dd>{{ formatPoints(row.points_after) }}</dd></div>
        </dl>
      </li>
    </ul>
    <div class="records-load-status" aria-live="polite">
      <span v-if="isLoadingMore">{{ $t('views.account_center.loading_more') }}</span>
      <span v-else-if="records.length && !hasMore">{{ $t('views.account_center.no_more_records') }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MobileConsumptionRecords',
  props: {
    records: { type: Array, default: () => [] },
    isLoading: Boolean,
    isLoadingMore: Boolean,
    hasMore: Boolean,
    eventName: { type: Function, required: true },
    hasDetails: { type: Function, required: true },
    detailKey: { type: Function, required: true },
    detailModelName: { type: Function, required: true },
    formatDate: { type: Function, required: true },
    formatChange: { type: Function, required: true },
    formatPoints: { type: Function, required: true },
    signedPointsChange: { type: Function, required: true }
  },
  emits: ['toggle-details', 'load-more'],
  data() {
    return { scrollHost: null, scrollFrame: null }
  },
  watch: {
    'records.length'() {
      this.scheduleScrollCheck()
    }
  },
  mounted() {
    // Consume the existing frame scroll; adding a list scroller would trap touch gestures.
    let host = this.$el.parentElement
    while (host && !/(auto|scroll)/.test(window.getComputedStyle(host).overflowY)) host = host.parentElement
    this.scrollHost = host || window
    this.scrollHost.addEventListener('scroll', this.checkScrollEnd, { passive: true })
    window.addEventListener('resize', this.scheduleScrollCheck)
    this.scheduleScrollCheck()
  },
  beforeUnmount() {
    this.scrollHost?.removeEventListener('scroll', this.checkScrollEnd)
    window.removeEventListener('resize', this.scheduleScrollCheck)
    if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame)
  },
  methods: {
    scheduleScrollCheck() {
      if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame)
      // Wait for the parent's request finally/render before measuring a newly appended page.
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null
        this.checkScrollEnd()
      })
    },
    checkScrollEnd() {
      if (!this.records.length || this.isLoading || this.isLoadingMore || !this.hasMore || !this.scrollHost) return
      const bottom = this.scrollHost === window
        ? window.innerHeight
        : this.scrollHost.getBoundingClientRect().top + this.scrollHost.clientTop + this.scrollHost.clientHeight
      if (this.$el.getBoundingClientRect().bottom - bottom <= 80) this.$emit('load-more')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/consumption_records';
</style>
